import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/app.component';
import {appConfig} from './app/app.config';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
} else {
  // ng serve liefert index.html direkt aus, ohne den NgResourceAdjuster des
  // Backends. Die dort hartkodierte absolute API-URL würde CORS auslösen, also
  // auf relativ stellen, damit proxy.conf.json (/dah -> localhost:8080) greift.
  (window as unknown as { API: string }).API = '/dah/data/';
}

bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]})
    .catch(err => console.error(err));
